"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _compact = _interopRequireDefault(require("lodash/compact"));

var _findLastIndex = _interopRequireDefault(require("lodash/findLastIndex"));

var _get = _interopRequireDefault(require("lodash/get"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _isNumber = _interopRequireDefault(require("lodash/isNumber"));

var _last = _interopRequireDefault(require("lodash/last"));

var _compose = _interopRequireDefault(require("lodash/fp/compose"));

var _constants = require("./constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function findActiveBreakpointTuple(width) {
  return function (breakpointTuples) {
    var firstBreakpointWidth = (0, _get.default)(breakpointTuples, '0.1');

    if (firstBreakpointWidth !== 0 && width < firstBreakpointWidth) {
      return [[_constants.sizes.XS, 0]];
    }

    var lastBreakpoint = (0, _last.default)(breakpointTuples);

    if (lastBreakpoint && width >= lastBreakpoint[1]) {
      return [lastBreakpoint];
    }

    return (0, _compact.default)([(0, _get.default)(breakpointTuples, (0, _findLastIndex.default)(breakpointTuples, function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          name = _ref2[0],
          minWidth = _ref2[1];

      return width >= minWidth;
    }))]);
  };
}

function sortBreakpointTuples(breakpointTuples) {
  return breakpointTuples.sort(function (_ref3, _ref4) {
    var _ref5 = _slicedToArray(_ref3, 2),
        keyA = _ref5[0],
        valA = _ref5[1];

    var _ref6 = _slicedToArray(_ref4, 2),
        keyB = _ref6[0],
        valB = _ref6[1];

    return valA - valB;
  });
}

function getActiveBreakpoint(dimensions, breakpoints) {
  var width = dimensions.width;

  if ((0, _isEmpty.default)(breakpoints) || !(0, _isNumber.default)(width)) {
    return undefined;
  }

  var breakpoint = breakpoints && (0, _get.default)((0, _compose.default)(findActiveBreakpointTuple(width), sortBreakpointTuples)(Object.entries(breakpoints)), '0.0');
  return breakpoint;
}

var _default = getActiveBreakpoint;
exports.default = _default;